import type { BlockKind } from '@/blocks/domain/types/BlockKind';
import type { Renderer } from '../../domain/RendererContract';
import * as Header from './HeaderRender';
import * as CustomerRender from './CustomerRender';
import * as ProseRender from './ProseRender';
import * as CustomRender from './CustomRender';
import * as ScopeFieldsRender from './ScopeFieldsRender';
import * as SignatureRender from './SignatureRender';
import * as SpacerRender from './SpacerRender';
import * as LineItemsTableRender from './LineItemsTableRender';
import * as TotalRender from './TotalRender';
import * as RolesResponsibilitiesRender from './RolesResponsibilitiesRender';
import * as PriceBookRender from './PriceBookRender';
import * as CoverPageRender from './CoverPageRender';

export const RENDERER_REGISTRY: Partial<Record<BlockKind, Renderer>> = {
  // Each renderer has a more specific content prop type (e.g. HeaderContent vs PriceBookContent).
  // The runtime selection is gated by `BlockKind`, so this cast is safe for our registry usage.
  header: Header.renderer as unknown as Renderer,
  customer_block: CustomerRender.renderer as unknown as Renderer,
  scope_of_work: ProseRender.scopeOfWorkRenderer as unknown as Renderer,
  comments: ProseRender.commentsRenderer as unknown as Renderer,
  terms_conditions: ProseRender.termsRenderer as unknown as Renderer,
  custom_text: ProseRender.customTextRenderer as unknown as Renderer,
  custom: CustomRender.renderer as unknown as Renderer,
  scope_fields: ScopeFieldsRender.renderer as unknown as Renderer,
  signature: SignatureRender.renderer as unknown as Renderer,
  spacer: SpacerRender.renderer as unknown as Renderer,
  line_items_table: LineItemsTableRender.renderer as unknown as Renderer,
  total: TotalRender.renderer as unknown as Renderer,
  roles_responsibilities: RolesResponsibilitiesRender.renderer as unknown as Renderer,
  price_book: PriceBookRender.renderer as unknown as Renderer,
  cover_page: CoverPageRender.renderer as unknown as Renderer
};
